import React from 'react';
import PropTypes from 'prop-types';
import moneyFormatter from 'money-formatter';

export const Quote = (props) => {
  const { quote, index, onChange } = props;
  return (
    <div className="custom-control custom-radio">
      <input className="custom-control-input" type="radio" name="quote" id={`quote-${index}`}
        value={index} checked={quote.selectedQuoteIndex}
        onChange={onChange} required/>
      <label htmlFor={`quote-${index}`}>
        <aside><i className="material-icons">done</i></aside>
        <div>
          <h2 className="term">{quote.termInMonths} months</h2>

          <section className="apr">
            <span>{quote.apr}%</span>
            <small>APR</small>
          </section>

          <section className="monthly">
            <span>{moneyFormatter.format('USD', quote.monthlyPayment.amount, 2)}</span>
            <small>per month</small>
          </section>
        </div>
      </label>
    </div>
  );
};


Quote.propTypes = {
  quote: PropTypes.shape({
    apr: PropTypes.number,
    termInMonths: PropTypes.number,
    monthlyPayment: PropTypes.shape({
      amount: PropTypes.number
    }),
    selectedQuoteIndex: PropTypes.number
  }).isRequired,
  onChange: PropTypes.func.isRequired
};

export default Quote;
